export function isPersistedRunningTimer(rawTimer) {
  return Boolean(
    rawTimer
    && rawTimer.running === true
    && Number.isFinite(Number(rawTimer.startReference))
    && Number(rawTimer.startReference) > 0,
  );
}

export function getElapsedMsFromStartReference(startReference, now = Date.now()) {
  const normalizedStartReference = Number(startReference);
  const normalizedNow = Number(now);
  if (!Number.isFinite(normalizedStartReference) || normalizedStartReference <= 0 || !Number.isFinite(normalizedNow)) {
    return 0;
  }

  return Math.max(0, normalizedNow - normalizedStartReference);
}

export function sanitizeSrhtTimerStates(defaultTimerStates, rawTimerStates) {
  const normalizedDefaults = defaultTimerStates && typeof defaultTimerStates === 'object' ? defaultTimerStates : {};
  const normalizedRawStates = rawTimerStates && typeof rawTimerStates === 'object' ? rawTimerStates : {};

  const dynamicCandidateEntries = Object.entries(normalizedRawStates)
    .filter(([timerKey, rawState]) => /^candidate_\d+$/.test(String(timerKey || '').trim()) && isPersistedRunningTimer(rawState))
    .map(([timerKey, rawState]) => ([
      String(timerKey),
      {
        running: true,
        startReference: Math.round(Number(rawState.startReference)),
      },
    ]));

  return Object.fromEntries([
    ...Object.entries(normalizedDefaults).map(([laneId, defaultState]) => {
      const rawState = normalizedRawStates[laneId];
      if (!isPersistedRunningTimer(rawState)) {
        return [laneId, { ...defaultState }];
      }

      return [laneId, {
        running: true,
        startReference: Math.round(Number(rawState.startReference)),
      }];
    }),
    ...dynamicCandidateEntries,
  ]);
}

export function buildAssessmentPersistentTimer(timerState) {
  if (!isPersistedRunningTimer(timerState) || !String(timerState.targetPath || '').trim()) {
    return null;
  }

  return {
    running: true,
    startReference: Math.round(Number(timerState.startReference)),
    targetPath: String(timerState.targetPath).trim(),
    targetLabel: String(timerState.targetLabel || ''),
  };
}

export function readAssessmentPersistentTimer(rawTimer) {
  if (!isPersistedRunningTimer(rawTimer) || !String(rawTimer.targetPath || '').trim()) {
    return null;
  }

  return {
    running: true,
    startReference: Math.round(Number(rawTimer.startReference)),
    targetPath: String(rawTimer.targetPath).trim(),
    targetLabel: String(rawTimer.targetLabel || ''),
  };
}